import styled from "styled-components";
import { themeVariables } from "../../../../theme/variables";

const ForgotPasswordPageStyled = styled.div`
    width: 75%;

    .page-header {
        margin-bottom: 3rem;

        .back-button {
            display: flex;
            align-items: center;

            margin-bottom: 1.5rem;
            margin-left: -0.7rem;

            span {
                color: gray;
            }
        }

        .title {
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-weight: ${() => themeVariables.fontWeights.bold};
            font-size: ${() => themeVariables.fontSizes.large}
        }

        .subtitle {
            margin: 0;
            margin-top: 0.5rem;
            color: gray;
        }
    }

    .input-elements {
        margin-bottom: 2rem;
    }

    .bottom-area {

    }
`;

export default ForgotPasswordPageStyled;